import {Component,type ErrorInfo,type ReactNode} from 'react';

type Props={children:ReactNode;resetKey?:string;scope?:'route'|'app'};
type State={error:Error|null};

/**
 * Last line of defence against a render crash blanking the whole page.
 * It only changes what is shown after a crash; it never swallows data, retries a write,
 * or bypasses any server-side check. Navigating to another route (resetKey) clears it.
 */
export class RouteErrorBoundary extends Component<Props,State>{
  state:State={error:null};
  static getDerivedStateFromError(error:unknown):State{return {error:error instanceof Error?error:new Error(String(error))}}
  componentDidCatch(error:Error,info:ErrorInfo){console.error('KPM screen crashed:',error,info.componentStack)}
  componentDidUpdate(previous:Props){if(this.state.error&&previous.resetKey!==this.props.resetKey)this.setState({error:null})}
  render(){
    if(!this.state.error)return this.props.children;
    const app=this.props.scope==='app';
    return <section className="private-workspace-empty" role="alert" aria-labelledby="screen-error-title">
      <p className="eyebrow">THIS SCREEN COULD NOT BE SHOWN</p>
      <h1 id="screen-error-title">Something went wrong on this screen</h1>
      <p>Nothing was sent or changed. {app?'Reload the page to try again.':'Reload to try again, or use the menu to open another screen.'} If it keeps happening, tell the KPM team what you were doing and include the detail below.</p>
      <p className="mono">{this.state.error.message.slice(0,300)}</p>
      <button type="button" className="button button--primary" onClick={()=>window.location.reload()}>RELOAD</button>
    </section>;
  }
}
